import React from "react";
import { Button, Flex, Stack, Text } from "@chakra-ui/react";
import { FiCheck, FiMapPin } from "react-icons/fi";
import StepLayout from "../components/StepLayout";

export default function CampusStep({ campuses, campusId, onSelect, onBack }) {
  return <StepLayout step={1} headerIcon={<FiMapPin/>} title="¿A qué campus pertenecen?" description="Presiona una opción para continuar." back={onBack}>
    <Stack gap="3" maxW="560px">
      {campuses.slice(0, 3).map((campus) => {
        const selected = campusId === campus.id;
        return <Button key={campus.id} h={{ base: "68px", lg: "62px" }} px="4" rounded="18px" justifyContent="flex-start" bg={selected ? "brand.redSubtle" : "public.bg.surface"} color="public.fg.default" borderWidth={selected ? "2px" : "1px"} borderColor={selected ? "red.500" : "public.border.default"} _dark={{ bg: selected ? "red.950" : "public.bg.surface", borderColor: selected ? "red.500" : "public.border.default" }} onClick={() => onSelect(campus.id)}>
          <Flex boxSize="38px" rounded="12px" bg={selected ? "red.600" : "public.bg.muted"} color={selected ? "gray.50" : "public.fg.muted"} align="center" justify="center" fontSize="19px"><FiMapPin/></Flex>
          <Text ml="4" fontSize="lg" fontWeight="800">{campus.nombre}</Text>
          <Flex ml="auto" boxSize="26px" rounded="full" bg={selected ? "red.600" : "public.bg.muted"} color={selected ? "gray.50" : "transparent"} align="center" justify="center">{selected && <FiCheck/>}</Flex>
        </Button>;
      })}
    </Stack>
  </StepLayout>;
}
